import React from 'react';

import { MediaTypes } from './enums';
import { getMediaType } from './utils';

type Props = {
  href: string;
  src: string;
  linkClassName?: string;
  creativeClassName?: string;
  onLoad?: (
    e: React.SyntheticEvent<HTMLImageElement | HTMLVideoElement>
  ) => void;
  onClick?: (e: React.SyntheticEvent<HTMLAnchorElement>) => void;
  children?: React.ReactElement;
};

export const AdsCreative = React.forwardRef<HTMLAnchorElement, Props>(
  (
    { href, src, linkClassName, creativeClassName, onLoad, onClick, children },
    ref
  ) => {
    const mediaType = getMediaType(src);

    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className={linkClassName}
        ref={ref}
        onClick={onClick}
      >
        {mediaType === MediaTypes.Image && (
          <img src={src} onLoad={onLoad} className={creativeClassName} alt="" />
        )}
        {mediaType === MediaTypes.Video && (
          <video
            className={creativeClassName}
            onLoadedData={onLoad}
            src={src}
            autoPlay
            loop
            muted
            playsInline
            disableRemotePlayback
          />
        )}
        {children}
      </a>
    );
  }
);
